<template>
    <div>
        <div
            v-show="font_category_list.length > 0 && font_heading"
            class="serach"
        >
            <div class="search_field position-relative mg-b-12">
                <input
                    type="text"
                    placeholder="Search here"
                    v-model="font_category_query"
                    class="form-control bg-transparent"
                    style="border-bottom: 1px solid #cccccc !important"
                />
                <a href="#" class="search_icon"
                    ><img src="/maincss/images/side_bar_serach.svg" alt=" "
                /></a>
            </div>
        </div>
        <div
            v-if="font_category_search.length > 0"
            v-show="font_heading"
            class="categorys font_category"
        >
            <div
                class="w-100 d-flex justify-content-center align-items-center desi_grid"
            >
                <div
                    v-for="(font_cate, index) in font_category_search"
                    :key="index"
                >
                    <template>
                        <a
                            href="#"
                            v-if="index % 2 == 0"
                            class="category_link w-100 d-flex justify-content-center align-items-center"
                            @click="open_font_tab(font_cate.id)"
                        >
                            {{ font_cate.name }}
                        </a>
                        <a
                            href="#"
                            v-if="
                                (index + 1) % 2 != 0 &&
                                index + 1 in font_category_search
                            "
                            class="category_link w-100 d-flex justify-content-center align-items-center"
                            @click="
                                open_font_tab(
                                    font_category_search[index + 1].id
                                )
                            "
                        >
                            {{ font_category_search[index + 1].name }}
                        </a>
                    </template>
                </div>
            </div>
        </div>
        <span v-else>No results found.</span>
        <div
            v-show="!font_heading"
            class="tools_headding catgory_headding w-100 add_txt text_shape_custom"
        >
            <span @click="close_fonts_tab()"
                ><img src="/maincss/images/tool_back_arrow.svg"
            /></span>
            <h4 @click="close_fonts_tab()" class="heading5">
                {{ category_name }}
            </h4>
        </div>
        <div class="categorys_open" v-show="font_list.length > 0">
            <div
                id="avatarlist"
                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
            >
                <div
                    class="form-check pl-0 font_style"
                    v-for="(font, index1) in font_list"
                    :key="index1"
                >
                    <label
                        class="checkbox_custom brand_logo_select"
                        :style="'fontFamily:' + font.font_option"
                        >{{
                            fontText
                                ? fontText.substring(0, 10)
                                : font.font_name.substring(0, 10)
                        }}
                        <input
                            class="clipart_item"
                            type="checkbox"
                            @click="setValue($event, font, index1)"
                        /><span
                            v-show="selected_font === index1"
                            class="checkmark"
                        ></span>
                    </label>
                </div>
            </div>
        </div>
        <span v-if="font_list.length == 0 && !font_heading"
            >No results found.</span
        >
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
export default {
    name: "FontType",
    props: ["value", "fontText"],
    data: () => {
        return {
            font_list: [],
            font_category_list: [],
            font_type: true,
            font_id: -1,
            font_type_list: false,
            selected_font: "",
            font_category_query: "",
            font_heading: true,
            category_name: ""
        };
    },
    mounted() {
        this.getFonts();
    },
    computed: {
        font_category_search() {
            if (this.font_category_query) {
                return this.font_category_list.filter((item) => {
                    return this.font_category_query
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item.name.toLowerCase().includes(v));
                });
            } else {
                return this.font_category_list;
            }
        }
    },
    methods: {
        //Select fonts from add text
        selectFont() {
            let _this = this;
            let font_category_data = "";
            let font_index = "";
            let prev_font = this.value;
            this.font_category_query = "";
            this.font_category_list.map((item, index) => {
                if (item.Fonts.length > 0) {
                    let font_category = item.Fonts.filter((item1, key) => {
                        if (item1.font_option == prev_font) {
                            font_index = key;
                            return true;
                        }
                    });
                    if (font_category.length > 0) {
                        font_category_data = item;
                        _this.open_font_tab(font_category_data.id);
                        this.selected_font = font_index;
                    }
                }
                console.log(index);
            });
        },
        // Close font category tab
        close_fonts_tab() {
            this.font_id = "";
            this.font_list = [];
            this.category_name = "";
            this.font_heading = true;
        },
        // Open font category tab
        open_font_tab(id) {
            let _this = this;
            this.font_id = id;
            let category_local = this.font_category_list.filter(function (
                val,
                key
            ) {
                //console.log(key);
                return val.id == id;
            });
            this.font_list = category_local[0].Fonts;
            if (this.font_list.length > 0) {
                let selectedFont = "";
                this.font_list.filter((font, index) => {
                    if (font.font_option == _this.value) selectedFont = index;
                });
                this.selected_font = selectedFont;
            }
            this.category_name = category_local[0].name;
            this.font_heading = false;
            //this.selected_font = '';
        },
        setValue(e, font, index2) {
            this.selected_font = index2;
            this.$emit("set-value", {
                font_option: font.font_option,
                font_name: font.font_name
            });
        },
        getFonts() {
            //get all fonts
            var _this = this;
            new Promise(() => {
                ApiService.get("/get-all-fonts")
                    .then(({ data }) => {
                        _this.font_category_list = data.category;
                        var newStyle = document.createElement("style");
                        let fonts = "";
                        data.category.forEach((element, key) => {
                            // console.log(key);
                            // if(element.name == 'Outline' && element.Fonts.length > 0 ){
                            if (element.Fonts.length > 0) {
                                element.Fonts.forEach((element1, key1) => {
                                    fonts +=
                                        "\
                  @font-face {\
                    font-family: '" +
                                        element1.font_option +
                                        "';\
                      src: url('" +
                                        element1.eot_file +
                                        "');\
                      src: url('" +
                                        element1.eot_file +
                                        "?#iefix') format('embedded-opentype'),\
                      url('" +
                                        element1.woff2_file +
                                        "') format('woff2'),\
                      url('" +
                                        element1.woff_file +
                                        "') format('woff'),\
                      url('" +
                                        element1.ttf_file +
                                        "') format('truetype'),\
                  font-weight: " +
                                        element1.weight +
                                        ";\
                  font-style: " +
                                        element1.style +
                                        ";\
                  font-display: " +
                                        element1.display +
                                        ";\
                  }\
                  ";
                                    //console.log(key1);
                                });
                            }
                        });
                        newStyle.appendChild(document.createTextNode(fonts));
                        document.head.appendChild(newStyle);
                    })
                    .catch(({ response }) => {
                        console.log(response.status.errors);
                    });
            });
        }
    }
};
</script>
